import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CompanyService } from '../../services/CompanyService/company';
import { CreateUserRequest } from '../../models/company.dto';
import { Role } from '../../models/auth.dto';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

const COMPANY_ROLES: Role[] = ['COMPANY_ADMIN', 'COMPANY_USER'];

@Component({
  selector: 'app-create-company-user-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
  ],
  templateUrl: './create-company-user-dialog.html',
  styleUrl: './create-company-user-dialog.scss',
})
export class CreateCompanyUserDialog {
  roles = COMPANY_ROLES;

  form: CreateUserRequest = { email: '', password: '', fullName: '', role: 'COMPANY_USER' };
  isSubmitting = signal(false);
  errorMessage = signal('');
  hidePassword = signal(true);

  constructor(private dialogRef: MatDialogRef<CreateCompanyUserDialog>, private company: CompanyService) {}

  get canSubmit(): boolean {
    return !!this.form.email.trim() && this.form.password.length >= 8 && !!this.form.fullName.trim();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.canSubmit) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.company.addUser(this.form).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to create user.'));
      },
    });
  }
}
